import React from "react";
import "./NodoDerivationTree.css";

function addColor(nodeData, word, acceptance) {
  if (nodeData.pos == word.length) {
    if (nodeData.final) {
      //green
      return "#bacdbe";
    } else if (nodeData.children.length == 0) {
      //red
      return "#d1674c";
    } else {
      return "rgb(248, 248, 255)";
    }
  } else {
    if (nodeData.children.length == 0 && !acceptance) {
      //red
      return "#d1674c";
    } else {
      //normal
      return "rgb(248, 248, 255)";
    }
  }
}
const MixedNodeElement = ({
  nodeData = {},
  triggerNodeToggle,
  foreignObjectProps = {},
  word = [],
  acceptance = "",
}) => {
  return (
    <React.Fragment>
      <circle r={5}></circle>
      <foreignObject {...foreignObjectProps}>
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            border: "1px solid black",
            paddingBottom: "1rem",
            backgroundColor: addColor(nodeData, word, acceptance),
          }}
        >
          <div className="tape">
            {word != undefined &&
              word.map((el, index) => {
                return (
                  <div key={index}>
                    {nodeData.pos == index ||
                    (nodeData.pos == word.length &&
                      nodeData.pos - 1 == index) ? (
                      <div
                        className={`div-container-element-tape-active ${
                          nodeData.pos == word.length &&
                          nodeData.pos - 1 == index
                            ? "last-element"
                            : ""
                        }`}
                      >
                        <div className="div-state-tape">
                          {nodeData.initial === true &&
                            nodeData.pos - 1 != index && <div>🢒</div>}
                          {nodeData.final === true ? (
                            <div
                              className={`div-element-tape-state-final ${
                                nodeData.pos == word.length &&
                                nodeData.pos - 1 == index
                                  ? "last"
                                  : "div-element-tape-state-normal"
                              }`}
                            >
                              <div className="element-tape-state">
                                {nodeData.name}
                              </div>
                            </div>
                          ) : (
                            <div
                              className={`${
                                nodeData.pos - 1 == index
                                  ? "last"
                                  : "div-element-tape-state-normal"
                              } `}
                            >
                              {nodeData.initial === true &&
                                nodeData.pos - 1 == index && <div>🢒</div>}
                              <div className={`element-tape-state `}>
                                {nodeData.name}
                              </div>
                            </div>
                          )}
                        </div>
                        <div className="arrow-active-state">↓</div>

                        <div className="div-element-tape">
                          <div className="element-tape">{el}</div>
                        </div>
                      </div>
                    ) : (
                      <div className="div-element-tape">
                        <div className="element-tape">{el}</div>
                      </div>
                    )}
                  </div>
                );
              })}
          </div>
          <div className="div-button-collapse">
            {nodeData.children && nodeData.children.length > 0 && (
              <button
                className={`button-collapse ${
                  nodeData.__rd3t.collapsed
                    ? "button-collapse-expand"
                    : "button-collapse-collapse"
                }`}
                onClick={triggerNodeToggle}
              >
                {nodeData.__rd3t.collapsed ? "+" : "-"}
              </button>
            )}
          </div>
        </div>
      </foreignObject>
    </React.Fragment>
  );
};

export default MixedNodeElement;
